import React from "react";
import { buildTranslator, RadioButtonColumnCustomFormField } from "../../../../amorg-common";
import { RadioButton } from "../../../../designSystem/inputs/RadioButton";
import styled from "styled-components";
import { tablet } from "../../../../designSystem/BreakPoints";
import { CustomFormFieldHeader } from "../../[parm]/_components/CustomFormFieldHeader";
import { AnswerFieldContext } from "../customFormFieldFactory";
import { CustomFormFieldFooter } from "../../[parm]/_components/CustomFormFieldFooter";
import { CustomFormFieldCard } from "../../[parm]/_components/CustomFormFieldCard";
import { colors } from "../../../../designSystem/colors/color";


type RadioButtonColumnCustomFormFieldComponentProps = AnswerFieldContext &{
    field:RadioButtonColumnCustomFormField
}
// eslint-disable-next-line @typescript-eslint/no-unused-vars
export function RadioButtonColumnCustomFormFieldComponent(props:RadioButtonColumnCustomFormFieldComponentProps):JSX.Element
{

    async function handleChange(value:string)
    {
        await props.onSubmit([{ fieldId: props.field.fieldId, value }]);
        props.doUpdate();
    }

    const answerField = props.answer.selections.find(s => s.fieldId === props.field.fieldId);
    const answerValue = answerField.value;

    const translator = buildTranslator('da');
    
    return (
        <section>
            <CustomFormFieldHeader field={props.field} />

            <CustomFormFieldCard>
                
                <RadioGridHeader>
                    <PreHeader>{translator(props.field.headerRow.cell1)}</PreHeader>
                    <PostHeader>{translator(props.field.headerRow.cell2)}</PostHeader>
                </RadioGridHeader>       
                
                {props.field.options.map((option, index) => {
                    const checked = option.value === answerValue;
                    return (

                        <label htmlFor={props.field.fieldId + "_" + option.value } key={index}>
                            
                            <RadioRow row={option.imageUrl ? 4 : 3}>
                                
                                {option.imageUrl &&
                                    <ImageSingle>
                                        <img src={`/images/ergocheck/${option.imageUrl}`} alt="Image image" />
                                    </ImageSingle>
                                }

                                <OptionHeader dangerouslySetInnerHTML={{ __html: translator(option.header) }} /> 
                               
                                <RadioContainer>
                                    <RadioButton
                                        disabled={props.disabled}
                                        name={props.field.fieldId + '_' + (props.inPrint ? '_print' : '')}
                                        id={props.field.fieldId + '_' + option.value + (props.inPrint ? '_print' : '')}
                                        onChange={handleChange}
                                        value={option.value}
                                        text={translator(option.content)}
                                        checked={checked}
                                    />
                                </RadioContainer>
                                {/* <OptionContent>
                                    
                                </OptionContent> */}
                            </RadioRow>
                        </label>
                    );
                })}
            </CustomFormFieldCard>
            {props.field.footer &&
                <CustomFormFieldFooter text={translator(props.field.footer)} />
            }
        </section>
    );
}

const ImageSingle = styled.div`
    display:grid;
    justify-self:center;
    align-self:center;
    grid-area: optionImage;


    & img{
        width:100%;
        object-fit:cover;
    }
`

export const PreHeader = styled.div`
    font-weight: 500;
`

export const PostHeader = styled.div`
    justify-self: center;
    font-weight: 500;
    
    @media only screen and (max-width: ${tablet}px) {
        justify-self:end;
    }
`



export const OptionHeader = styled.div`
    display:grid;
    grid-area:optionHeader;
    border-right: 1px solid ${colors.table.border};
    padding-right: 8px;
    
    & b{
        font-weight: 500;
    }    

    & ul{
        padding-left:20px;
    }

    @media (max-width: ${tablet}px) {
        
    }
`

export const RadioContainer = styled.div`
    display:grid;
    grid-area:radioButton;
    justify-self:center;
    align-self:center;

    & ul{
        padding:0 !important;
        margin:0;
    }

    & label{
        margin-left: 16px;
    }
`

export const OptionContent = styled.div`
    display:grid;
    grid-area:optionContent;
    justify-self:center;
    align-self:center;
`

export const RadioGridHeader = styled.div`
    display:grid;
    background-color: ${props => props.theme.colors.customForm.answer.formFieldCard.cardHeader.background};
    color:${props => props.theme.colors.customForm.answer.formFieldCard.cardHeader.text};
    padding: 16px;
    grid-template-columns: 80% 20%;

    margin: 0 -1rem 0 -1rem;

    @media only screen and (max-width: ${tablet}px) {
        grid-template-columns: 50% 50%;
    }
`



export const RadioRow = styled.div<{row:number}>`
    border-bottom: 1px solid ${colors.table.border};
    padding:8px;
    display:grid;
    
    grid-template-columns: ${props => props.row === 4 ? '45% 45% 10%' : '90% 10%'};
    grid-template-areas: ${props => props.row === 4 ? '"optionImage optionHeader radioButton"' : '"optionHeader radioButton"' };

    & ul{
        margin:0;
    }

    

    @media only screen and (max-width: ${tablet}px) {
        & ul{
            padding-left:16px;
        }

        grid-template-columns: '84% 8% 8%';
    }
`